import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import {Toolbar} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
    topBar: {
        backgroundColor: 'rgb(38, 55, 82)',
    }
}));

const Header = (props) => {
    const styles = useStyles();

    return (
        <div>
            <AppBar position="fixed" className={styles.topBar}>
                <Toolbar>
                    <Grid justify="center" container>
                        <Typography variant="h6" noWrap>
                            {props.title}
                        </Typography>
                    </Grid>
                </Toolbar>
            </AppBar>
        </div>
    )
};

export default Header;
